import { render, staticRenderFns } from "./uploadFile.vue?vue&type=template&id=eff2f7d4&scoped=true&"
import script from "./uploadFile.vue?vue&type=script&lang=ts&"
export * from "./uploadFile.vue?vue&type=script&lang=ts&"
import style0 from "./uploadFile.vue?vue&type=style&index=0&id=eff2f7d4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff2f7d4",
  null
  
)

export default component.exports